// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2K0up","sendOtp":"AuthorizeToLogin_sendOtp__2C_zx"};